import { render, staticRenderFns } from "./AcceptLicenseAction.vue?vue&type=template&id=08a5b658&scoped=true"
import script from "./AcceptLicenseAction.vue?vue&type=script&lang=ts"
export * from "./AcceptLicenseAction.vue?vue&type=script&lang=ts"
import style0 from "./AcceptLicenseAction.vue?vue&type=style&index=0&id=08a5b658&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a5b658",
  null
  
)

export default component.exports